module.exports = __webpack_public_path__ + "img/1F1EC-1F1F2.60a5d8c3.svg";